import { render } from "./BookingExpiredPage.vue?vue&type=template&id=55218bba&scoped=true"
import script from "./BookingExpiredPage.vue?vue&type=script&lang=js"
export * from "./BookingExpiredPage.vue?vue&type=script&lang=js"

import "./BookingExpiredPage.vue?vue&type=style&index=0&id=55218bba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55218bba"]])

export default __exports__